import {Currency} from '@app/shared';

export interface ServicePricing{
  // cotizacion total
  totalQuantity: number
  totalUnit: Unit
  totalPrice: number
  totalCost: number
  totalDiscount: number
  totalSaleVat: number
  totalPurchaseVat: number
  //cotizacion unitaria
  unitQuantity: number
  unit: Unit
  unitPrice: number
  unitCost: number
  unitDiscount: number
  currency: Currency
  unitPurchaseVat: number
  unitSaleVat: number
  currencyId: number
}
export enum Unit {
  Order = 'Order',
  LoadUnit = 'LoadUnit',
  Package = 'Package',
  Good = 'Good',
  NotDefined = 'NotDefined'
}
